<div class="background-box">
    <div class="background-box__top"></div>
    <div class="background-box__bottom"></div>
</div>
<div class="page-wrapper">
    <ng-content></ng-content>
</div>
